import moment from 'moment'

export const SOCIETE_DOUBLE_POINTS_TAKEOVER_ID = 'societe-double-points'

export const SOCIETE_DOUBLE_POINTS_START_DATE = moment('2025-12-04T00:00:00+1100')
